module.exports = __webpack_public_path__ + "static/urban4-42fb75e45a0e8f73d5ff9aa9c7243af6.jpg";